export function formatDate(datetime) {
  if (!datetime) {
    return "-";
  }

  // Handle both "YYYY-MM-DD HH:MM:SS" and ISO 8601 "YYYY-MM-DDTHH:MM:SS.000000Z" formats
  let datePart;
  if (datetime.includes("T")) {
    // ISO 8601 format
    datePart = datetime.split("T")[0];
  } else {
    // Standard format with space separator
    datePart = datetime.split(" ")[0];
  }

  const date = new Date(datePart + "T00:00:00");

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
}

export function formatDatetime(datetime) {
  if (!datetime) {
    return "-";
  }

  const date = new Date(datetime);
  
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
}